var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eyesO",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424.07,259.27c.61,6.96,1.24,14.15,2.01,22.99,11.46-5.43,21.98-10.02,32.14-15.31,19.26-10.03,38.37-20.36,57.44-30.76,19.08-10.41,38.05-21.05,57.04-31.62,5.41-3.01,10.76-6.15,16.05-9.18,3.75,3.61,3.66,6.25-.29,8.88-7.33,4.88-14.74,9.64-21.94,14.34,2.37,7.96,5.65,15.4,6.59,23.12,1.01,8.3,2.5,16.58,1,25.37-1.77,10.36-3.67,20.55-7.82,30.14-9.71,22.46-26.22,38.36-48.58,47.99-12.28,5.29-25.53,7.01-38.57,5.03-13-1.97-25.28-6.5-35.85-15.37-7.66-6.43-13.23-14.03-18.22-22.42-1.08-1.82-3.11-3.37-5.05-4.35-6.96-3.5-10.78-9.1-11.19-16.7-.38-6.99-.38-14.03.03-21.02.43-7.22,6.89-12.07,15.21-11.12h0ZM514.24,269.95c-15.3,14.5-31.4,24.18-50.85,30.43,2.59,2.68,4.72,5.06,7.03,7.25,9.64,9.19,26,8.27,34.39-1.73,6.3-7.52,8.9-16.5,10.37-25.86.45-2.87-.51-5.96-.94-10.09h0Z",
    className: "main-eye-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.6,351c-28.4-1.16-48.95-11.46-65.27-30.09-9.61-10.97-16.01-23.98-19.28-38.1-2.09-9.01-3.25-18.5-3.02-27.72.26-10.14,2.08-20.34,6.82-29.66,1.92-3.78,3.07-6.71-2.26-9.48-6.49-3.38-12.17-8.28-18.3-12.37-2.43-1.62-3.68-3.54-2.2-6.21,1.53-2.75,3.38-1.83,5.77-.47,23.66,13.42,47.36,26.78,71.17,39.93,22.97,12.69,46.04,25.2,69.18,37.59,4.84,2.59,10.1,4.44,15.27,6.35,3.13,1.16,4.18-.97,4.25-3.64.09-4,.16-8-.01-12-.14-3.33.51-6.68,4.2-6.53,2.69.1,6.36,1.73,7.76,3.87,6.04,9.25,5.24,19.46,3.54,29.94-1.36,8.37-6.31,12.55-13.17,16.4-3.13,1.76-4.67,6.44-6.78,9.89-9.1,14.84-23.02,23.23-38.99,28.43-7.02,2.29-14.54,3.05-18.69,3.87h0ZM283.78,270.17c-4.21,14.96,1.15,31.39,12.82,38.98,5.02,3.26,10.73,6.13,17.11,5.06,8.98-1.5,16.19-6,21.43-13.97-18.96-6.85-35.95-16.57-51.36-30.07Z",
    className: "main-eye-color"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M514.24,269.95c.43,4.13,1.39,7.22.94,10.09-1.47,9.36-4.07,18.34-10.37,25.86-8.39,10.01-24.75,10.93-34.39,1.73-2.3-2.2-4.44-4.57-7.03-7.25,19.44-6.25,35.54-15.93,50.85-30.43h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.78,270.17c15.41,13.5,32.4,23.22,51.36,30.07-5.24,7.96-12.45,12.46-21.43,13.97-6.38,1.07-12.09-1.79-17.11-5.06-11.67-7.59-17.04-24.02-12.82-38.98Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesO);
export default __webpack_public_path__ + "static/media/eyesO.4790e8d158a76d9ee0aa8652724d7720.svg";
export { ForwardRef as ReactComponent };